import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'

interface IProps {
  selected: boolean;
  amount: number;
  onChange: () => void;
}

const WechatSimpleItem: FC<IProps> = ({ selected, amount, onChange }) => {
  const handleChange = () => {
    onChange()
  }
  return (
    <div
      className={classNames('pay-method-item', 'wechat-pay-web', { selected })}
      data-cypid='wechatSimpleItem'
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-a-WeChatpay'></i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          <div className='name'>{i18n.t('pay.wechatPay')}</div>
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(WechatSimpleItem)
